var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 44,
    viewBox: "0 0 72 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4a4 4 0 0 1 4-4h64a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4zm38 18c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15zm13-6a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-3a4 4 0 0 0-4-4h-8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 10a1.914 1.914 0 0 0-1.662 2.679l2.7 6.654a1.773 1.773 0 0 0 3.33 0l2.7-6.654A1.916 1.916 0 0 0 25.7 10h-5.4zM25.7 34a1.919 1.919 0 0 0 1.665-2.682l-2.7-6.654a1.773 1.773 0 0 0-3.33 0l-2.7 6.654A1.916 1.916 0 0 0 20.3 34h5.4zM32.32 17.65l-6.656 2.7a1.773 1.773 0 0 0 0 3.33l6.657 2.685A1.915 1.915 0 0 0 35 24.7v-5.385a1.915 1.915 0 0 0-2.68-1.665zM13.679 26.353l6.657-2.685a1.773 1.773 0 0 0 0-3.33l-6.657-2.7A1.913 1.913 0 0 0 11 19.303V24.7a1.914 1.914 0 0 0 2.679 1.653zM52.5 23a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM57.5 23a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatPump);
export default __webpack_public_path__ + "static/media/heat-pump.30c69278006658dc9314f0fba71023ee.svg";
export { ForwardRef as ReactComponent };